import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Icon,
  Input,
  Select,
  SelectOption,
  TablePagination,
  Text,
} from '@fairfashion/design-system'

import { useDebounceValue } from '../../hooks/useDebounceValue'
import { OrderProductionStatus } from '../../sdk/order-production/order-production.types'

import { OrderProductionsStatistics } from './components/OrderProductionsStatistics/order-productions-statistics.comp'
import { OrderProductionsTable } from './components/OrderProductionsTable/order-productions-table.comp'
import {
  OrderProductionsContext,
  OrderProductionsProvider,
} from './order-productions.context'
import * as Styles from './order-productions.styles'

const statusOptions: SelectOption[] = [
  {
    label: 'Todos',
    value: 'all',
  },
  {
    label: 'Em andamento',
    value: 'pending',
  },
  {
    label: 'Concluídos',
    value: 'complete',
  },
]

type OrderProductionStatusSelect = 'all' | OrderProductionStatus

const OrderProductionsComp = () => {
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState<OrderProductionStatusSelect>('all')

  const { totalCount, actions } = useContext(OrderProductionsContext)

  useEffect(() => {
    actions.fetchOrderProductions()
  }, [])

  const searchCodeDebounced = useDebounceValue(search, 1000)

  useEffect(() => {
    const _status = status === 'all' ? undefined : status

    actions.fetchOrderProductions(
      page,
      itemsPerPage,
      _status,
      searchCodeDebounced,
    )
  }, [page, itemsPerPage, searchCodeDebounced, status])

  return (
    <Box direction="column" gap={2} width="100%" padding={3}>
      <Styles.Title size="large">Gestão de Processos Produtivos</Styles.Title>

      <OrderProductionsStatistics />

      <Box marginTop={2}>
        <Text>Últimos processos</Text>
      </Box>

      <Styles.TableContainer>
        <Box
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
          marginBottom={2}
        >
          <Box width="400px" maxWidth="100%">
            <Input
              adornment={<Icon name="search" color="grey_2" />}
              adornmentPosition="left"
              placeholder="Buscar por processo produtivo"
              width="100%"
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
          <Select
            width="200px"
            placeholder="Status"
            options={statusOptions}
            onChange={(e) =>
              setStatus(e.target.value as OrderProductionStatusSelect)
            }
          />
        </Box>

        <OrderProductionsTable />

        <Box width="100%" marginTop={1}>
          <TablePagination
            total={totalCount}
            current={page}
            itemsPerPage={itemsPerPage}
            onChange={(_page) => setPage(_page)}
            onChangeItemsPerPage={(_itemsPerPage) =>
              setItemsPerPage(_itemsPerPage)
            }
          />
        </Box>
      </Styles.TableContainer>
    </Box>
  )
}

export const OrderProductions = () => {
  return (
    <OrderProductionsProvider>
      <OrderProductionsComp />
    </OrderProductionsProvider>
  )
}
